var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-col',{attrs:{"xl":_vm.content.columns,"cols":"12"}},[_c('h4',{staticClass:"lm-subtitle"},[_vm._v(_vm._s(_vm.content.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }